import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomeFilter from './HomeFilter';

const TopLosers = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const fetchTopLosers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/coins/top-losers`);
        
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        
        let data = await response.json();
        
        // Handle API errors
        if (data.error) {
          throw new Error(data.error);
        }
        
        // Safely process and sort data
        data = data
          .map(coin => ({
            ...coin,
            price_change_percentage_24h: coin.price_change_percentage_24h || 0,
            market_cap: coin.market_cap || 0,
            current_price: coin.current_price || 0
          }))
          .filter(coin => coin.price_change_percentage_24h < 0)
          .sort((a, b) => {
            // Safe comparison with fallback to 0
            const aChange = a.price_change_percentage_24h || 0;
            const bChange = b.price_change_percentage_24h || 0;
            return aChange - bChange;
          });
        
        setCoins(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching top losers:', err);
        setError('Failed to load top losers. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchTopLosers();
    
    // Optional: Refresh data every 5 minutes
    const interval = setInterval(fetchTopLosers, 300000);
    return () => clearInterval(interval);
  }, []);

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
  <>
    {path === '/top-losers' && (
      <div className="toppagetitle">
        <div className="container">
          <div className="pagetitle">
            <h1>Top Losers</h1>
          </div>
        </div>
      </div>
    )}
    <HomeFilter coins={coins} />
  </>
  );
};

export default TopLosers;